import { CardActions, CardHeader, Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import parse from "html-react-parser";
import { useStyles } from "../../tickets/TicketStyle";

export default function TicketEditCard(props: any) {
  const { name, content, date, colorHeader, colorBody } = props;
  const classes = useStyles();

  return (
    <Grid item xs={8}>
      <Card className={(classes.root, classes.marginTop2)} style={{ backgroundColor: colorBody }}>
        <CardHeader
          title={name}
          style={{ backgroundColor: colorHeader }}
          titleTypographyProps={{ variant: "body2", color: "textSecondary" }}
        ></CardHeader>
        <CardContent className={classes.marginTopNegative}>{content && <div>{parse(content)}</div>}</CardContent>
        <CardActions>
          <Grid container direction="column" justifyContent="flex-end" alignItems="flex-end">
            <Typography variant="body2" color="textSecondary">
              {date}
            </Typography>
          </Grid>
        </CardActions>
      </Card>
    </Grid>
  );
}
